export enum PAYMENT_METHOD_ID {
    CreditCard = 0,
    PreauthCapture = 1,
    DirectDebit = 2,
    Cash = 3,
    Dias = 4,
    CardPresent = 6,
    Wallet = 8,
    Alipay = 9,
    IDeal = 10,
    P24 = 11,
    Blik = 12,
    PayU = 13,
    Multibanco = 14,
    GiroPay = 15,
    DirectPay = 16,
    Eps = 17,
    WeChatPay = 18,
    BitPay = 19,
    ApplePay = 20,
    GooglePay = 21,
    SamsungPay = 22,
    PayPal = 23,
    Trustly = 24,
    Klarna = 26,
    BancontactQRCode = 27,
    Payconiq = 28,
    Iris = 29,
    PaymentInitiation = 30,
    MultibancoWay = 31,
    MultibancoReference = 32,
    TbiBnpl = 34,
    PayOnDelivery = 35,
    MobilePay = 36,
    BancomatPay = 37,
    ClickToPay = 38,
    Swish = 39,
    BlikDirect = 40,
    BlueCode = 41,
    GiroPayDirect = 42,
    Satispay = 43,
    Wero = 45
}
